<template>
  <div>
     <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div>  -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Query Report Level 1</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row class="sub-row" justify="center" dense>
        <v-col cols="12" xs="12" sm="2" lg="2" md="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="usertype"
            return-object
            :items="usertype_list"
            item-text="name"
            item-value="id"
            label="User Type"
            outlined
          />
        </v-col>
        <v-col cols="12" xs="12" sm="2" lg="2" md="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="roletype"
            return-object
            :items="roletype_list"
            item-text="name"
            item-value="id"
            label="Module"
            outlined
          />
        </v-col>
        <v-col cols="12" xs="12" sm="2" lg="2" md="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="query_type"
            return-object
            :items="querytype_list"
            item-text="name"
            item-value="id"
            label="Query Type"
            outlined
          />
        </v-col>
        <v-col cols="12" xs="12" sm="2" lg="2" md="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="querystatus"
            return-object
            :items="querystatus_list"
            item-text="name"
            item-value="id"
            label="Query Status"
            outlined
          />
        </v-col>
        <v-col cols="12" xs="12" sm="2" lg="2" md="12">
          <br />
          <v-btn
            class="toolbar"
            outlined
            dense
            rounded
            :loading="loader"
            @click="fetchQueries" v-if="querystatus && query_type && roletype && usertype"
          >
            Fetch Queries</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <!-- {{old_queries}} -->
    <v-card class="box">
      <v-row dense>
          <v-col cols="12" sm="6" md="6" class="ml-3">
              <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'QueryReport')"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
          </v-col>
      </v-row>
      <v-toolbar flat >
        <v-toolbar-title>
          <v-row>
            <v-btn small color="rgb( 249, 255, 196 )">New</v-btn>
            <v-btn small color="rgb( 211, 223, 255 )">Inprocess</v-btn>
            <v-btn small color="rgb( 255, 196, 196 )">Forward</v-btn>
            <v-btn small color="rgb( 137, 255, 196 )">Closed</v-btn>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
        <v-dialog v-model="dialog" max-width="800px">
          <v-card>
            <v-card-title class="toolbar">
              <span>Edit Query</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.ticketid"
                      label="Query Ticket Id"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.title"
                      label="Query Title"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.desc"
                      label="Query Description"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.url"
                      label="Query URL"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.module"
                      label="Query Module"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.query_type"
                      label="Query Type"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.date"
                      label="Query Date"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                      dense
                      v-model="editedItem.query_status_id"
                      :items="querystatus_list"
                      item-text="name"
                      item-value="id"
                      label="Query Status"
                      persistent-hint
                      single-line
                    ></v-select>
                    <!-- <v-text-field
                      v-model="editedItem.query_status"
                      label="Query Status"
                    ></v-text-field> -->
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.query_level"
                      label="Query Level"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" sm="2" v-if="editedItem.attachment.length != 0">
                    <a
                      :href="basepath+editedItem.attachment"
                      target="_blank"
                      v-if="editedItem.attachment.length != 0"
                      ><v-icon right>mdi-file</v-icon>File Attachment</a
                    >
                  </v-col>
                  <v-col cols="2" sm="2" v-if="editedItem.url != null">
                    <a :href="editedItem.url" target="_blank"><span v-if="editedItem.url != null"><v-icon right>mdi-open-in-new</v-icon>Open attached URL</span></a>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      v-model="editedItem.query_remark"
                      class="mx-2"
                      label="Any Remark..."
                      rows="1"
                      prepend-icon="mdi-comment"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
              <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
      id="my-table-id"
      fixed-header
      height="400px"
        :headers="headers"
        :items="old_queries"
        :search="search"
      ><template #item="{ item }">
        <tr :class="customRowClass(item)">
          <td>{{ item.srno }}</td>
          <td>{{ item.ticketid }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.desc }}</td>
          <td>
             <span v-if="item.url!= null && item.url!='' ">
               <a :href="item.url" target="_blank">URL</a>
            </span>
            <span v-else>--</span>
            </td>
          <td><a
            :href="basepath+item.attachment"
            target="_blank"
            v-if="item.attachment.length != 0"
            >Attachment</a
          ></td>
          <td>{{ item.date }}</td>
          <td>{{ item.module }}</td>
          <td>{{ item.query_type }}</td>
          <td>{{ item.user }}</td>
          <td>{{ item.query_status.name }}</td>
          <td>{{ item.query_level }}</td>
          <td><v-icon small class="mr-2" @click="editItem(item)">
            mdi-square-edit-outline
          </v-icon></td>
        </tr> 
    </template>
        <!-- <template v-slot:item.url="{ item }">
          <a :href="item.url" target="_blank">{{ item.url }}</a>
        </template>
        <template v-slot:item.attachment="{ item }">
         
          <a
            :href="item.attachment"
            target="_blank"
            v-if="item.attachment.length != 0"
            >Attachment</a
          >
        </template>
        <template v-slot:item.query_status="{ item }">
          <span v-if="item.query_status != null">{{
            item.query_status.name
          }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-square-edit-outline
          </v-icon>
        </template> -->
      </v-data-table>
    </v-card>
   
    <v-overlay :value="progress">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    search: '',
    progress: false,
    // extraBreadcrumbItems: [
   

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    usertype_list: [],
    roletype_list: [],
    querytype_list: [],
    querystatus_list: [],
    old_queries: [],
    query_type: "",
    querystatus: "",
    roletype: "",
    usertype: "",
    headers: [
      {
        text: "Sr. No.",
        value: "srno",
      },
      {
        text: "Ticket Id",
        value: "ticketid",
      },
      {
        text: "Title",
        value: "title",
      },
      {
        text: "Description",
        value: "desc",
      },
      {
        text: "URL",
        value: "url",
      },
      {
        text: "Attachment",
        value: "attachment",
      },
      {
        text: "Date",
        value: "date",
      },
      {
        text: "Module",
        value: "module",
      },
      {
        text: "Query Type",
        value: "query_type",
      },
      {
        text: "Query Raised By",
        value: "user",
      },
      {
        text: "Query Status",
        value: "query_status",
      },
      {
        text: "Query Level",
        value: "query_level",
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
      },
    ],
    loader: false,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    color: "",
    basepath: "",
    dialog: false,
    editedItem: {
      id: "",
      ticketid: 0,
      title: "",
      desc: "",
      url: "",
      attachment: "",
      date: "",
      module: "",
      query_type: "",
      query_status: "",
      query_level: "",
      query_remark: "",
      query_status_id:""
    },
  }),
  methods: {
    customRowClass:function (item) {
      if(item.query_status.name =="New"){
        return 'style-1'
      }else if(item.query_status.name =="Closed"){
        return 'style-2'
      }else if(item.query_status.name =="Forward"){
        return 'style-3'
      }else if(item.query_status.name =="Inprocess"){
        return 'style-4'
      }
  },
  fnExcelReport(id, name) {
    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
    tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
    tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
    tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
    tab_text = tab_text + "<table style='border-collapse:collapse;' border='1'>";
    var exportTable = $("#" + id).clone();
    exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
    });
    exportTable.find('th, td').each(function() {
        $(this).css('border', '1px solid black');
    });
    tab_text = tab_text + exportTable.html();
    tab_text = tab_text + "</table></body></html>";
    var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
    const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const filename = name+'.xls';

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        // For modern browsers
    const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    close() {
      this.dialog = false;
      this.onLoad();
    },
    save() {
      this.progress = true;
      let data = {
        query_status: this.editedItem.query_status_id,
        id: this.editedItem.id,
        query_remark: this.editedItem.query_remark,
      };
      axios
        .post("/Query/saveLevelOneChanges", data)
        .then((res) => {
          if (res.data.flag == "YES") {
          this.showSnackbar("green", "Updated Successfully..!");
            this.dialog = false;
            this.onLoad();
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.progress = false;
           this.onLoad();
        });
    },
    editItem(item) {
      this.progress = true;
      this.editedItem = Object.assign({}, item);
      axios
        .post("/Query/changeQueryStatus", this.editedItem)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.progress = false;
            this.dialog = true;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.progress = false;
        });
    },
    onLoad() {
      this.progress = true;
      axios
        .post("/Query/getLevelOneReport")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.progress = false;
              (this.usertype_list = res.data.usertype_list),
              (this.querytype_list = res.data.querytype_list),
              (this.querystatus_list = res.data.querystatus_list),
              (this.roletype_list = res.data.roletype_list),
              (this.old_queries = res.data.queries_list)
          }
           else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
           }
          else {
            this.progress = false;
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.progress = false;
        });
    },
    fetchQueries() {
      if (this.usertype.length == 0) {
        this.showSnackbar("#b71c1c", "Please select User Type!");
        return;
      }
      if (this.roletype.length == 0) {
        this.showSnackbar("#b71c1c", "Please select Module!");
        return;
      }
      if (this.query_type.length == 0) {
        this.showSnackbar("#b71c1c", "Please select Query Type!");
        return;
      }
      if (this.querystatus.length == 0) {
        this.showSnackbar("#b71c1c", "Please select Query Status!");
        return;
      }
      this.old_queries=[]
      let data = {
        usertype: this.usertype.id,
        roletype: this.roletype.id,
        querytype: this.query_type.id,
        querystatus: this.querystatus.id,
      };
      this.progress = true;
      axios
        .post("/Query/fetchLevelOneReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.progress = false;
            this.old_queries = res.data.queries_list;
            this.querystatus_list = res.data.querystatus_list;
          }
         else if (res.data.flag == "No") {
              this.showSnackbar("#b71c1c", res.data.snackbar);
          }  else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.progress = false;
        });
    },
  
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.basepath = localStorage.getItem("awspath");
    this.onLoad();
  },
};
</script>

<style scoped>
.card-container {
        overflow-x: hidden;
        overflow: hidden;
    }
.style-1 {
  background-color: rgb( 249, 255, 196 )
}
.style-2 {
  background-color: rgb( 137, 255, 196 )
}
.style-3 {
  background-color: rgb( 255, 196, 196 )
}
.style-4 {
  background-color: rgb(211, 223, 255)
}
.tc-title {
  background-image: linear-gradient(-90deg, #fff, blue);
  color: #fff;
  border-radius: 3px;
}

@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
  }
  td + td,
  th + th {
    width: auto;
  }
}
sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

.v-card__title {
  border: 1px solid #80808040;
  font-weight: bold;
  background-color: #424093;
  color: white;
  text-align: center;
  /* margin-top: 1.5rem; */
}
.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  /* padding: 5px; */
  /* margin: 1rem !important; */
  width: auto;
}

.tx-bold {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

i {
  font-size: 26px;
  cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #424093 !important;
  color: white !important;
  margin-top: 2.35rem;
  border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {
}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}

@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}

@media all and (min-width: 1000px) {
  .padding-metting {
    padding-right: 22px;
  }
}
@media (min-width: 320px) and (max-width: 350px) {
  .padding-bot {
    font-size: 11.6px;
  }
}
@media (min-width: 1000px) and (max-width: 1050px) {
  .padding-bot {
    font-size: 9.6px;
  }
}
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
</style>
